import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { GuideDocumentData } from 'app/shared/model';
import { BaseBasicDialog } from '../model';

@Component({
    selector: 'app-guideline-document-dialog',
    templateUrl: './guideline-document-dialog.component.html',
    styleUrls: ['./guideline-document-dialog.component.scss'],
})

export class GuidelineDocumentDialogComponent extends BaseBasicDialog {
    constructor(
        public dialogRef: MatDialogRef<GuidelineDocumentDialogComponent>,
        protected _fuseTranslationLoaderService: FuseTranslationLoaderService,
        protected _fuseProgressBarService: FuseProgressBarService,
        @Inject(MAT_DIALOG_DATA) public data: GuideDocumentData
    ) {
        super(dialogRef, _fuseTranslationLoaderService, _fuseProgressBarService);
    }
}
